import moment from 'moment-timezone';

export interface ConfiguredFeedingTimes {
    morning: string;
    afternoon: string;
    evening: string;
}

const parseTimeToMinutes = (timeStr: string): number => {
    if (!timeStr || !timeStr.includes(':')) return 0;
    const [h, m] = timeStr.trim().split(':').map(Number);
    return (h ?? 0) * 60 + (m ?? 0);
};

export const minutesToDisplayLabelForTz = (minutes: number, timeZone: string): string =>
    moment
        .tz('2000-01-01', timeZone)
        .startOf('day')
        .add(minutes, 'minutes')
        .format('h:mm a')
        .replace(/\s/g, '')
        .toLowerCase();

export const getTimeOptionsForMoment = (
    momentId: number,
    configured: ConfiguredFeedingTimes,
    timeZone: string
): Array<{ value: string; label: string }> => {
    const morningMin = parseTimeToMinutes(configured.morning);
    const afternoonMin = parseTimeToMinutes(configured.afternoon);
    const eveningMin = parseTimeToMinutes(configured.evening);

    let start: number;
    let end: number;

    if (momentId === 1) {
        start = morningMin;
        end = Math.max(morningMin, afternoonMin - 15);
    } else if (momentId === 2) {
        start = afternoonMin;
        end = Math.max(afternoonMin, eveningMin - 15);
    } else if (momentId === 3) {
        start = eveningMin;
        end = 23 * 60 + 45;
    } else {
        return [];
    }

    const options: Array<{ value: string; label: string }> = [];
    for (let minutes = start; minutes <= end; minutes += 15) {
        const label = minutesToDisplayLabelForTz(minutes, timeZone);
        options.push({ value: label, label });
    }
    return options;
};

export const getDefaultTimeForMoment = (
    momentId: number,
    configured: ConfiguredFeedingTimes,
    timeZone: string
): string => {
    const opts = getTimeOptionsForMoment(momentId, configured, timeZone);
    const configuredTimeStr =
        momentId === 1
            ? configured.morning
            : momentId === 2
            ? configured.afternoon
            : momentId === 3
            ? configured.evening
            : '';
    const configuredMinutes = parseTimeToMinutes(configuredTimeStr);
    const configuredDisplay = minutesToDisplayLabelForTz(configuredMinutes, timeZone);
    const inOptions = opts.find(o => o.value === configuredDisplay);
    return inOptions?.value ?? opts[0]?.value ?? configuredDisplay ?? '';
};
